import { ApplicationConfig, importProvidersFrom, Injectable, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { provideMaterial } from './core/providers/material.provider';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG, provideClientHydration } from '@angular/platform-browser';
// import * as Hammer from 'hammerjs';
import { loaderInterceptor } from './core/interceptors/loading.interceptor';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';
// import { RecaptchaInterceptor } from './core/interceptors/recaptcha.interceptor';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = {
    // Manually use the numeric values for Hammer directions to avoid the static import
    // DIRECTION_ALL is 30
    swipe: { direction: 30 }, 
    pan: { direction: 30 }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor, 
        loaderInterceptor
      ])
    ),
    provideRouter(
      routes, 
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      }),
      withComponentInputBinding()
    ),
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    // { provide: HTTP_INTERCEPTORS, useClass: RecaptchaInterceptor, multi: true },
    // { provide: APP_BASE_HREF, useValue: '/' },
    provideMaterial(),
    provideAnimationsAsync(),
    provideNgxStripe(environment.stripe.publish),
    importProvidersFrom(HammerModule),
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig }
  ]
};
